import { useMemo } from 'react';
import { useAppSelector } from '@/core/global-store';

function collectPermissionNames(me: Record<string, unknown> | null): string[] {
    if (!me?.roles || !Array.isArray(me.roles)) {
        return [];
    }
    const names = new Set<string>();
    for (const r of me.roles as Array<{ permissions?: Array<{ name?: string }> }>) {
        for (const p of r.permissions ?? []) {
            if (p?.name) {
                names.add(p.name);
            }
        }
    }
    return [...names];
}

/** All permission name strings for the logged-in user (union across roles). */
export function usePermissionNames(): string[] {
    const me = useAppSelector((s) => s.auth.me) as Record<string, unknown> | null;
    return useMemo(() => collectPermissionNames(me), [me]);
}

export function useHasPermission(permission: string): boolean {
    const names = usePermissionNames();
    return names.includes(permission);
}
